import { useState } from "react";

const ImageMessage = ({ message }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleImageClick = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const [isZoomed, setIsZoomed] = useState(false);

  const handleDoubleClick = () => {
    setIsZoomed(prev => !prev);
  };

  // Close modal when clicking outside
  const handleClickOutside = (event) => {
    // console.log("Called");
    console.log(event.target.closest(".modal-content"));
    if (isOpen && !event.target.closest(".modal-content")) {
      handleClose();
    }
  };


  return (
    <>
      <span className="gap-2 cursor-pointer">
        <img
          src={message?.media?.file}
          alt="Image"
          className="max-w-full rounded-lg"
          onClick={handleImageClick}
        />
        {message?.message && <div className="mt-2">{message?.message}</div>}
      </span>

      {/* Modal */}
      {isOpen && (
        <div
          onClick={handleClickOutside}
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 "
        >
          <img
            src={message?.media?.file}
            alt="Zoomed"
            onDoubleClick={handleDoubleClick}
              className={`modal-content max-h-[90vh] max-w-[90vw] rounded-lg transform transition-transform duration-300 cursor-zoom-in ${
              isZoomed ? "scale-150 cursor-zoom-out" : "scale-100"
            }`}
          />
        </div>
      )}
    </>
  );
};

export default ImageMessage;
